/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SolutionBranch } from '../models/solution-branch';
import { SolutionDepartment } from '../models/solution-department';
import { Solution } from '../models/solution';
@Injectable({
  providedIn: 'root',
})
class SolutionStoreService extends __BaseService {
  static readonly SolutionStoreGetAvailableSolutionBranchesPath = '/solution-store/branches';
  static readonly SolutionStoreGetAvailableSolutionDepartmentsPath = '/solution-store/departments';
  static readonly SolutionStoreGetAvailableSolutionsPath = '/solution-store/solutions';
  static readonly SolutionStoreCreateVaultFromSolutionPath = '/solution-store/solutions/{solutionId}/vaults';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns all branches for the given culture
   * @param params The `SolutionStoreService.SolutionStoreGetAvailableSolutionBranchesParams` containing the following parameters:
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SolutionStoreGetAvailableSolutionBranchesResponse(params: SolutionStoreService.SolutionStoreGetAvailableSolutionBranchesParams): __Observable<__StrictHttpResponse<Array<SolutionBranch>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.languageCultureName != null) __params = __params.set('languageCultureName', params.languageCultureName.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/solution-store/branches`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SolutionBranch>>;
      })
    );
  }
  /**
   * Returns all branches for the given culture
   * @param params The `SolutionStoreService.SolutionStoreGetAvailableSolutionBranchesParams` containing the following parameters:
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SolutionStoreGetAvailableSolutionBranches(params: SolutionStoreService.SolutionStoreGetAvailableSolutionBranchesParams): __Observable<Array<SolutionBranch>> {
    return this.SolutionStoreGetAvailableSolutionBranchesResponse(params).pipe(
      __map(_r => _r.body as Array<SolutionBranch>)
    );
  }

  /**
   * Returns all departments for the given culture
   * @param params The `SolutionStoreService.SolutionStoreGetAvailableSolutionDepartmentsParams` containing the following parameters:
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SolutionStoreGetAvailableSolutionDepartmentsResponse(params: SolutionStoreService.SolutionStoreGetAvailableSolutionDepartmentsParams): __Observable<__StrictHttpResponse<Array<SolutionDepartment>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.languageCultureName != null) __params = __params.set('languageCultureName', params.languageCultureName.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/solution-store/departments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SolutionDepartment>>;
      })
    );
  }
  /**
   * Returns all departments for the given culture
   * @param params The `SolutionStoreService.SolutionStoreGetAvailableSolutionDepartmentsParams` containing the following parameters:
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SolutionStoreGetAvailableSolutionDepartments(params: SolutionStoreService.SolutionStoreGetAvailableSolutionDepartmentsParams): __Observable<Array<SolutionDepartment>> {
    return this.SolutionStoreGetAvailableSolutionDepartmentsResponse(params).pipe(
      __map(_r => _r.body as Array<SolutionDepartment>)
    );
  }

  /**
   * Returns only available solutions
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  SolutionStoreGetAvailableSolutionsResponse(Authorization: string): __Observable<__StrictHttpResponse<Array<Solution>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/solution-store/solutions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Solution>>;
      })
    );
  }
  /**
   * Returns only available solutions
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  SolutionStoreGetAvailableSolutions(Authorization: string): __Observable<Array<Solution>> {
    return this.SolutionStoreGetAvailableSolutionsResponse(Authorization).pipe(
      __map(_r => _r.body as Array<Solution>)
    );
  }

  /**
   * Create vault from chosen solution
   * @param params The `SolutionStoreService.SolutionStoreCreateVaultFromSolutionParams` containing the following parameters:
   *
   * - `solutionId`: GUID of the solution
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return Created
   */
  SolutionStoreCreateVaultFromSolutionResponse(params: SolutionStoreService.SolutionStoreCreateVaultFromSolutionParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.languageCultureName != null) __params = __params.set('languageCultureName', params.languageCultureName.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/solution-store/solutions/${encodeURIComponent(String(params.solutionId))}/vaults`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * Create vault from chosen solution
   * @param params The `SolutionStoreService.SolutionStoreCreateVaultFromSolutionParams` containing the following parameters:
   *
   * - `solutionId`: GUID of the solution
   *
   * - `languageCultureName`: Language culture name
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return Created
   */
  SolutionStoreCreateVaultFromSolution(params: SolutionStoreService.SolutionStoreCreateVaultFromSolutionParams): __Observable<{}> {
    return this.SolutionStoreCreateVaultFromSolutionResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }
}

namespace SolutionStoreService {

  /**
   * Parameters for SolutionStoreGetAvailableSolutionBranches
   */
  export interface SolutionStoreGetAvailableSolutionBranchesParams {

    /**
     * Language culture name
     */
    languageCultureName: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }

  /**
   * Parameters for SolutionStoreGetAvailableSolutionDepartments
   */
  export interface SolutionStoreGetAvailableSolutionDepartmentsParams {

    /**
     * Language culture name
     */
    languageCultureName: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }

  /**
   * Parameters for SolutionStoreCreateVaultFromSolution
   */
  export interface SolutionStoreCreateVaultFromSolutionParams {

    /**
     * GUID of the solution
     */
    solutionId: string;

    /**
     * Language culture name
     */
    languageCultureName: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { SolutionStoreService }